/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class EvaluationRequest extends MainRequest{

    static listAllByType(data) {
         return this.postSEC(ServicePath.EVALUATION_LIST_BY_TYPE, data);
    }

    static listByPersonAndType(data) {
        return this.postSEC(ServicePath.EVALUATION_LIST_PERSON_AND_TYPE, data);
    }

    static saveEvaluations(data) {
        return this.postSEC(ServicePath.EVALUATION_SAVE, data);
    }

    static listAll() {
        return this.postSEC(ServicePath.EVALUATION_LIST_ALL);
   }

   static add(data) {
        return this.postSEC(ServicePath.EVALUATION_ADD, data);
    }
    static update(data) {
        return this.postSEC(ServicePath.EVALUATION_UPDATE, data);
    }
        
    static deleteQuestion(data) {
        return this.postSEC(ServicePath.EVALUATION_DELETE_QUESTION, data);
    }
    static deleteAnswer(data) {
        return this.postSEC(ServicePath.EVALUATION_DELETE_ANSWARE, data);
    }

    static deleteEvaluation(data) {
        return this.postSEC(ServicePath.EVALUATION_DELETE_EVALUATION, data);
    }

 }